// plugins/alert.client.ts
import { useAlert } from '~/composables/useAlert'

export default defineNuxtPlugin(() => {
  const alert = useAlert()

  // Dodaj na globalnu instancu
  return {
    provide: {
      alert,
    },
  }
})
